
import { Reducer } from 'redux';
import { STATE } from 'app/constants';
import { mergeReducers } from 'app/infrastructure/redux/merge-reducers';
import { withOptionsReducer } from 'app/components/options-handler';
import { ExternalUrlGroupsState } from './types-store';
import { reducer as externalUrlGroupsFormReducer, INITIAL_STATE as externalUrlGroupsFormState } from './form/reducers';
import { reducer as externalUrlGroupsListReducer, INITIAL_STATE as externalUrlGroupsListState } from './list/reducers';

export const INITIAL_STATE: ExternalUrlGroupsState = {
  form: externalUrlGroupsFormState,
  list: externalUrlGroupsListState
};

export const reducer: Reducer<ExternalUrlGroupsState> = withOptionsReducer(
  STATE.externalUrlGroups,
  mergeReducers({
    form: externalUrlGroupsFormReducer,
    list: externalUrlGroupsListReducer
  })
);
